import * as containerAction from '../actions/containerAction';
import * as issuerAction from '../actions/issuerAction';
import { endLoading, startLoading } from '../actions/loadingAction';
import { getUrlContainerApi, isNullOrEmpty, parseParams, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';

const httpService = new HttpService(getUrlContainerApi(window));

export default class ContainerService {
    //#region  Area Virutal

    static getAreasPaged(filter, callback) {
        const url = '/api/area/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(containerAction.setAreaVirtualPaged(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertArea(model, callback) {
        const url = '/api/area';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteArea(id, callback) {
        const url = `/api/area/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static exportAreaCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/area/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static setAreaVirtual(area) {
        return (dispatch) => { dispatch(containerAction.setAreaVirtual(area)); };
    }

    //#endregion 

    //#region  Position

    static getPositionPaged(filter, callback) {
        const url = '/api/position/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(containerAction.setPositionPaged(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getPositions(filter, callback) {
        const url = 'api/position/list';
        return (dispatch) => {
            if (navigator.onLine) {

                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setPositionsAll(response.data.data));
                        if (callback) {
                            callback(response.data.data)
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    callback()
                }).finally(() => {

                });
            }
        };
    }

    static insertPosition(model, callback) {
        const url = '/api/position';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deletePosition(id, callback) {
        const url = `/api/position/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteListPosition(ids, callback) {
        const url = `/api/position/selected`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, ids).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }


    static exportPositionsCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/position/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    //#endregion 

    //#region  Ponto de Descarga

    static getUnloadLocationPaged(filter, callback) {
        const url = '/api/unloadlocation/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(containerAction.setUnloadLocationPaged(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getUnloadLocation(filter, callback) {
        const url = '/api/unloadlocation/all';
        return (dispatch) => {
            if (navigator.onLine) {
                // dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(containerAction.setUnloadLocationList(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
                // .finally(() => {
                //     dispatch(endLoading());
                // });
            }
        };
    }

    static insertUnloadLocation(model, callback) {
        const url = '/api/unloadlocation';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateUnloadLocation(model, callback) {
        const url = '/api/unloadlocation';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteUnloadLocation(id, callback) {
        const url = `/api/unloadlocation/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteListUnloadLocation(ids, callback) {
        const url = `/api/unloadlocation/selected`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, ids).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static exportUnloadLocationCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/unloadlocation/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static uploadUnloadLocation(file, callback) {
        const url = '/api/unloadlocation/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static setUnloadLocation(unloadlocation) {
        return (dispatch) => { dispatch(containerAction.setUnloadLocation(unloadlocation)); };
    }

    //#endregion 

    //#region Aviepx

    static getAviexpPaged(filter) {
        const url = 'api/aviexp/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setAviexpPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static associeteContainerAviexp(data, callback) {
        const url = 'api/aviexp/associatecontainer';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data).then((response) => {
                    if (response.status === 200) {
                        callback();
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static exportClickCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/aviexp/reportclick?aviexpId=${filter}`,
                    {
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static updateAviexp(data, callback) {
        const url = 'api/aviexp';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data).then((response) => {
                    if (response.status === 200) {
                        callback();
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    //#endregion 

    //#region Container

    static getContainerPaged(filter) {
        const url = 'api/container/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                    }).then((response) => {
                        if (response.status === 200) {
                            dispatch(containerAction.setContainerPaged(response.data.data));
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        return error;
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getContainerExplosionPaged(filter) {
        const url = 'api/container/explosion/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getContainerExplosion(filter, callback) {
        const url = 'api/container/explosion';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        callback(response.data.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
    static getContainer(filter, callback) {
        const url = 'api/container';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getContainerMvm(filter, callback) {
        const url = 'api/container/mvmnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback(response.data.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getContainerChange(filter, callback) {
        const url = 'api/container/change';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static sendContainerChange(data, callback) {
        const url = 'api/containerItem/change';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, data).then((response) => {
                    if (response.status === 200 && callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static sendContainerSpawning(data, callback) {
        const url = 'api/containerItem/spawning';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, data).then((response) => {
                    if (response.status === 200 && callback) {
                        callback();
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insert(model, callback) {
        const url = '/api/container';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static update(model, callback) {
        const url = '/api/container';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteContainer(id, callback) {
        const url = `/api/container/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static exportContainerCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/container/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static exportContainerDetailCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/container/detail/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static exportContainerItemCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/containeritem/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static exportContainerStatusSearchCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/container/status-detail/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    //Removido o loading e deixou para o componente.
    static updateContainerByAllocation(model, callback) {
        const url = '/api/container';
        return (dispatch) => {
            httpService.instance.put(url, model).then(() => {
                if (callback) {
                    callback();
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                dispatch(endLoading());
            })
        }
    }

    static allocationContainer(data, callback) {
        const url = '/api/containerlocation';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, data).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }



    static getPagedStatus(filter) {
        const url = 'api/container/status-detail/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'Erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
    //#endregion

    //#region Issuer

    static insertIssuer(model, callback) {
        const url = '/api/issuer';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static getIssuers(vision, filter) {
        const url = 'api/issuer/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(issuerAction.setIssuerPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateIssuer(model, callback) {
        const url = '/api/issuer';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }
    static deleteIssuer(id, callback) {
        const url = `/api/issuer/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static exportIssuerCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/issuer/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    //#endregion

    //#region Schedule Calculation
    static getScheduleCalculation(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/schedulecalculation/list`, {
                    params: filter,
                }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200 && response.data?.data) {
                            if (callback) {
                                callback(response.data?.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }

    static addScheduleCalculation(data, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/schedulecalculation`, data, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deleteScheduleCalculation(id, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(`/api/schedulecalculation/${id}`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback();
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }

    //#endregion 

    //#region Pecas Criticas

    static getCriticalParts(filter) {
        const url = 'api/criticalpartnumber/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setCriticalPartsPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteCriticalPart(id, callback) {
        const url = `/api/criticalpartnumber/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteCriticalParts(ids, callback) {
        const url = `/api/criticalpartnumber/deleteIds?ids=${ids.join(`&ids=`)}`;

        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static exportCriticalPartsCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/criticalpartnumber/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static insertCriticalPart(model, callback) {
        const url = '/api/criticalpartnumber';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateCriticalPart(model, callback) {
        const url = '/api/criticalpartnumber';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static uploadCriticalParts(file, callback) {
        const url = '/api/criticalpartnumber/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static getCriticalPartEmails(vision) {
        const url = 'api/criticalpartnumber/emails';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setCriticalPartEmails(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertCriticalPartEmail(model, callback) {
        const url = '/api/criticalpartnumber/email';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(response.data);
                    }
                }
            }).catch((error) => {
                const errorMessages = error.response?.data?.errors?.Email?.join(',') || error.response?.data?.message || error.message;
                showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteCriticalPartEmail(id, callback) {
        const url = `/api/criticalpartnumber/email/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }


    static getPartNumberDescription(partNumberCode, callback) {
        const url = `api/criticalpartnumber/get-description/${partNumberCode}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        callback(response.data?.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    //#endregion

    //#region Container Types

    static UpdateStatusContainer(data, callback) {
        const url = `api/container/status`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback(response.data.data)
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    const errorMessages = error.response?.data?.message || error.message;
                    showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getStatusContainer() {
        const url = `api/container/status`;

        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerStatus(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    const errorMessages = error.response?.data?.message || error.message;
                    showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static getContainerTypes(filter, vision) {
        const url = `api/container/container-type`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerTypes(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    const errorMessages = error.response?.data?.message || error.message;
                    showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertContainerType(model, callback) {
        const url = '/api/container/container-type';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(response.data);
                    }
                }
            }).catch((error) => {
                const errorMessages = error.response?.data?.message || error.message;
                showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateContainerType(model, callback) {
        const url = '/api/container/container-type';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(response.data);
                    }
                }
            }).catch((error) => {
                const errorMessages = error.response?.data?.message || error.message;
                showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteContainerType(ids, callback) {
        const url = `/api/container/container-type?ids=${ids.join(`&ids=`)}`;

        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static uploadContainerTypes(file, callback) {
        const url = '/api/container/container-type-upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }
    //#endregion

    //#region Container Sizes

    static getContainerSizes(filter) {
        const url = `api/container/container-size`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerSizes(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertContainerSize(model, callback) {
        const url = '/api/container/container-size';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(response.data);
                    }
                }
            }).catch((error) => {
                const errorMessages = error.response?.data?.message || error.message;
                showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateContainerSize(model, callback) {
        const url = '/api/container/container-size';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(response.data);
                    }
                }
            }).catch((error) => {
                const errorMessages = error.response?.data?.message || error.message;
                showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteContainerSize(ids, callback) {
        const url = `/api/container/container-size?ids=${ids.join(`&ids=`)}`;

        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static uploadContainerSizes(file, callback) {
        const url = '/api/container/container-size-upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }
    //#endregion

    //#region Plant Config

    static getPlantConfig(callback) {
        const url = `api/plantconfig`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setPlantConfig(response.data.data));
                        if (callback) callback(response.data.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updatePlantConfig(model, callback) {
        const url = '/api/plantconfig';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    dispatch(containerAction.setPlantConfig(model));
                    if (callback) callback(response.data);
                }
            }).catch((error) => {
                const errorMessages = error.response?.data?.message || error.message;
                showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }
    // #endregion

    //#region Business HoursConfig

    static getBusinessHoursConfig(callback) {
        const url = `api/businesshoursconfig`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setBusinessHoursConfig(response.data.data));
                        if (callback) callback(response.data.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateBusinessHoursConfig(model, callback) {
        const url = '/api/businesshoursconfig';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    dispatch(containerAction.setBusinessHoursConfig(model));
                    if (callback) callback(response.data);
                }
            }).catch((error) => {
                const errorMessages = error.response?.data?.message || error.message;
                showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }
    // #endregion

    //#region Companhias Maritimas

    static getMaritimeCompany(filter, callback) {
        const url = 'api/maritimecompany/all';
        return (dispatch) => {
            if (navigator.onLine) {

                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setMaritimeCompanyAll(response.data.data));
                        callback(response.data.data)
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    callback()
                }).finally(() => {

                });
            }
        };
    }


    static getPagedMaritimeCompany(filter) {
        const url = 'api/maritimecompany/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setMaritimeCompanyPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertMaritimeCompany(model, callback) {
        const url = '/api/maritimecompany';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateMaritimeCompany(model, callback) {
        const url = '/api/maritimecompany';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteMaritimeCompany(id, callback) {
        const url = `/api/maritimecompany/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    // #endregion

    //#region COBERTURA - PARAMETRIZACAO DO PN

    static getPagedCoveragePartNumber(filter) {
        const url = 'api/coveragepartnumber/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setCoveragePartNumberPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertCoveragePartNumber(model, callback) {
        const url = '/api/coveragepartnumber';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateCoveragePartNumber(model, callback) {
        const url = '/api/coveragepartnumber';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteCoveragePartNumber(id, callback) {
        const url = `/api/coveragepartnumber/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static getPartNumberCoverage(partNumberCode, callback) {
        const url = `api/coveragepartnumber/partnumberdescription/${partNumberCode}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        callback(response.data?.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    // #endregion

    //#region Portos

    static getAllHarbor(filter, callback) {
        const url = 'api/harbor/all';
        return (dispatch) => {
            if (navigator.onLine) {

                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setHarborAll(response.data.data));
                        callback(response.data.data)
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {

                });
            }
        };
    }

    static getPagedHarbor(filter) {
        const url = 'api/harbor/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setHarborPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertHarbor(model, callback) {
        const url = '/api/harbor';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateHarbor(model, callback) {
        const url = '/api/harbor';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteHarbor(id, callback) {
        const url = `/api/harbor/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    // #endregion

    //#region FreeTime

    static getPagedFreeTime(filter) {
        const url = 'api/freetime/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setFreetimePaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertFreeTime(model, callback) {
        const url = '/api/freetime';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateFreeTime(model, callback) {
        const url = '/api/freetime';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteFreeTime(id, callback) {
        const url = `/api/freetime/${id}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    // #endregion

    //#region  container status log

    static getContainerHistoryPaged(filter) {
        const url = 'api/containerstatuslog/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerHistoryPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static exportContainerHistoryCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/containerstatuslog/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    //#endregion 

    //#region MDR


    static getMdrPaged(filter) {
        const url = 'api/mdr/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setMdrPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getMdr(filter, callback) {
        const url = 'api/mdr';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback(response.data.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertMdr(model, callback) {
        const url = '/api/mdr';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static updateMdr(model, callback) {
        const url = '/api/mdr';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(true);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static deleteMdr(id, callback) {
        const url = `/api/mdr?ids=${id.join(`&ids=`)}`;
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.delete(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static exportMdrCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/mdr/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static uploadMdr(file, callback) {
        const url = '/api/mdr/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }
    //#endregion 

    //#region  Consulta por Desenho

    static getContainerItemPaged(filter, callback) {
        const url = 'api/containerItem/explosion/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerItemPaged(response.data.data));
                        if (callback) {
                            callback()
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getContainerItemPartNumberPaged(filter) {
        const url = 'api/containerItem/partnumbers';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainersItemPartNumberPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static exportContainerItemPartNumberCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/containeritem/partnumbers/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    //#endregion

    //#region  Datas Container

    static getDatesContainer(filter, callback) {
        const url = 'api/container/logstatus';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateDatesContainer(data, callback) {
        const url = `api/container/referenceDate`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback()
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    const errorMessages = error.response?.data?.message || error.message;
                    showMessageToastCustom(translate('warning', 'general'), errorMessages, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    //#endregion

    //#region Demurrage

    static getPagedMonitor(filter) {
        const url = 'api/container/monitor/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setContainerPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'Erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static exportMonitorCsv(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/container/monitor/report/csv`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    //#endregion

    //#region  Alertas Email 

    static getAlertEmail = (filter) => {
        const url = 'api/alertemail/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(containerAction.setAlertsPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertAlertEmail = (email, callback) => {
        const url = 'api/alertemail';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, { email }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    static deleteAlertEmail = (id, callback) => {
        const url = 'api/alertemail';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${id}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback({ message: "Item excluido com sucesso" });
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }
    //#endregion

    //#region  Upload File

    static uploadFilePackaging(file, callback) {
        const url = '/api/uploadfilepackaging/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('file', file);
                httpService.instance.post(url, formData).then((response) => {
                    if (isNullOrEmpty(response.data.data)) {
                        showMessageToastCustom(translate('confirmed', 'general'), "Arquivo processado com sucesso.", 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        let result = [];
                        var keys = Object.keys(response.data.data);
                        keys.map((key) => result.push({ code: key, message: response.data.data[key] }))
                        if (callback) {
                            callback(result);
                        }
                    }

                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    //#endregion

    //#region Cobertura

    static getCoveragePaged(filter) {
        const url = 'api/coverage/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                    }).then((response) => {
                        if (response.status === 200) {
                            dispatch(containerAction.setCoveragePaged(response.data.data));
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        return error;
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }


    //#endregion

    //#region  Import Container

    static uploadContainer(file, showModal, save, callback) {
        const url = '/api/containerimport/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);
                formData.append('showModal', showModal);
                formData.append('save', save);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    //#endregion
}